<template>
<body id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio member-page-section loa-cons-last-page" id="portfolio">
            <div class="container">
                
                <div class="row align-items-start">
                    <div class="col loa-steps steps-done">
                      1
                    </div>
                    <div class="col loa-steps steps-done">
                      2
                    </div>
                    <div class="col loa-steps steps-done">
                      3
                    </div>
                    <div class="row justify-content-center loa-form">
                        <div class="login-form">
                            <p class="lead custom-notice option-notice">
                                Do you have other transactions?
                                <a type="button" class="btn btn-primary btn-lg yes-no-option"><router-link to="/member-page">YES</router-link></a>
                            <a type="button" class="btn btn-primary btn-lg yes-no-option"><router-link to="/login">NO</router-link></a>
                            </p>
                              
                        </div>
                       <div class="col-md-12 loa-btn member-custom-btn">
                  <a style="float:left" type="button" class="btn btn-primary btn-lg"><router-link to="/member-page">CANCEL</router-link></a>
                  <a type="button" class="btn btn-primary btn-lg"><router-link to="">PREVIOUS</router-link></a>
                  <button class="btn btn-primary btn-lg"><router-link to="">PRINT</router-link></button>
            </div>
                </div>
        </div>
            </div>
        </section>
</body>
</template>


<script>
import axios from 'axios';
export default {
  name: 'DoctorName',
  data() {
    return {
      certNo: '',
      TokenID: '',
      LastName: '',
      FirstName: '',
      Doctors: []


    }
  },
  methods: {
    async handleSearch() {
      this.TokenID = localStorage.getItem('TokenID')
        const response = await axios.post('/api/?action=member-doctor-name', {
           FirstName: this.FirstName,
           TokenID: this.TokenID,
           LastName: this.LastName
        }, 
        );

        console.log(response);
        this.Doctors=response.data

        
        
    }
    
  }
  }



</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
